import { Theme, css } from '@emotion/react';

export const dialogFormStyles = ({ spacing }: Theme) => css`
  display: flex;
  max-height: calc(100% - ${spacing(8)}px);
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
`;
